import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

interface FileData {
  url: string;
  filename: string;
}

const manualFaqAPI = {
  // 매뉴얼 다운로드 API
  async getManualAPI(): Promise<FileData> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.manualController.getManual(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      // 파일 이름 추출
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'ulvac_manual.pdf';

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch.length > 1) {
          filename = decodeURIComponent(filenameMatch[1].replace(/\+/g, ' '));
        }
      }

      return { url, filename };
    } catch (error) {
      console.error('downloadFile 실패 :', error);
      throw error;
    }
  },
  // 파일 다운로드 API
  async getFaqAPI(): Promise<FileData> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.faqController.getFaq(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        responseType: 'blob'
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      // 파일 이름 추출
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'ulvac_faq.pdf';

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch.length > 1) {
          filename = decodeURIComponent(filenameMatch[1].replace(/\+/g, ' '));
        }
      }

      return { url, filename };
    } catch (error) {
      console.error('downloadFile 실패 :', error);
      throw error;
    }
  }
};

export const { getManualAPI, getFaqAPI } = manualFaqAPI;
